.row {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px var(--pad);
  background: none;
  border: 0;
  text-align: left;
  -webkit-tap-highlight-color: transparent;
}

.tappable {
  cursor: pointer;
}

.tappable:active {
  background: var(--surface-sunken);
}

.row + .row {
  /* Разделитель начинается после иконки — так ряды читаются как список,
     а не как отдельные полосы. */
  box-shadow: inset 0 1px 0 var(--line);
}

.disabled {
  opacity: 0.5;
  cursor: default;
}

.tile {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
  background: var(--surface-sunken);
  color: var(--ink-soft);
}

.body {
  flex: 1 1 auto;
  min-width: 0;
}

/*
 * display: block обязателен. Разметка строки собрана из <span>, потому что
 * строка бывает кнопкой, а <button> по спецификации содержит только
 * строчное содержимое. Без этого объявления заголовок и подпись встают
 * в одну строку, а text-overflow на строчном элементе не действует —
 * длинное название распирает строку и сдвигает цену.
 */
.title,
.subtitle {
  display: block;
}

/* Заголовок — всегда одна строка: он короткий, и перенос в нём читается
   как две разные строки списка. */
.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 500;
}

/* Подпись переносится, а не обрезается. Многоточие здесь прячет ровно то,
   ради чего подпись и написана, — а строка списка вполне может быть
   в две строки высотой. */
.subtitle {
  font-size: 13px;
  line-height: 1.35;
  color: var(--muted);
}

.value {
  flex: 0 0 auto;
  font-size: 16px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.chevron {
  flex: 0 0 auto;
  color: var(--muted);
}
